import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fold",
  "use": "icon-fold-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fold\">\n    <title>icon/Pack up</title>\n    <g id=\"icon-fold_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-fold_新建设备控制日程-VCB-1920*1080\" transform=\"translate(-1221.000000, -231.000000)\">\n            <g id=\"icon-fold_pop\" transform=\"translate(628.000000, 215.000000)\">\n                <g id=\"icon-fold_icon/Pack-up\" transform=\"translate(593.000000, 16.000000)\">\n                    <rect id=\"icon-fold_矩形\" x=\"0\" y=\"0\" width=\"16\" height=\"16\" />\n                    <polygon id=\"icon-fold_路径-2\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" points=\"12.6464466 5.64644661 13.3535534 6.35355339 8 11.7071068 2.64644661 6.35355339 3.35355339 5.64644661 8 10.293\" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fold.svg
// module id = 5pIo
// module chunks = 35